import { render } from "./TheHeader.vue?vue&type=template&id=04d4d596&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=04d4d596&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d4d596"]])

export default __exports__